import { AssignIdentityFormValues } from './types';

export const ASSIGN_IDENTITY_STEP_IDS = {
  teams: 'teams',
  rolesAndAttributes: 'rolesAndAttributes',
};

export interface AssignIdentityStepConfig {
  id: string;
  label: string;
  fields: Array<keyof AssignIdentityFormValues>;
}

export const ASSIGN_IDENTITY_STEPS: AssignIdentityStepConfig[] = [
  {
    id: ASSIGN_IDENTITY_STEP_IDS.teams,
    label: 'Select team',
    fields: ['teamIds'],
  },
  {
    id: ASSIGN_IDENTITY_STEP_IDS.rolesAndAttributes,
    label: 'Roles and attributes',
    fields: ['contents'],
  },
];

export const ASSIGN_IDENTITY_STEP_LABELS = ASSIGN_IDENTITY_STEPS.map(
  step => step.label,
);

export function getAssignIdentityStepFields(
  stepIndex: number,
): Array<keyof AssignIdentityFormValues> {
  return ASSIGN_IDENTITY_STEPS[stepIndex]?.fields ?? [];
}
